import { useEffect, useState } from 'react';

import { api } from 'services/api';

export function useLocationCategories(): string[] {
  const [locationCategories, setLocationCategories] = useState<string[]>([]);

  useEffect(() => {
    api
      .get<{ data: string[] }>('/admin/filter-options/location-categories')
      .then(({ data }) => setLocationCategories(data))
      .catch(err => Promise.reject(err.message));
  }, []);

  return locationCategories;
}
